<template>
  <div id="app">
    <AppHeader />
    <main class="app-main">
      <router-view />
    </main>
    <GlobalContactForm />
    <AppFooter />
    <div class="wechat-work-container">
      <a :href="wechatWorkLink"
         target="_blank"
         rel="noopener noreferrer"
         class="wechat-work-icon"
         title="添加我的企业微信与我联系吧"
         aria-label="添加我的企业微信与我联系吧">
        <div class="wechat-work-bg">
          <img :src="wechatWorkIcon"
               alt="企业微信"
               width="40"
               height="40">
        </div>
        <div class="wechat-work-text">企业微信</div>
      </a>
    </div>

    <!-- Back to Top Button -->
    <transition name="fade">
      <button v-show="showBackToTop"
              class="back-to-top"
              @click="scrollToTop"
              aria-label="Back to Top">
        <svg viewBox="0 0 24 24"
             width="24"
             height="24"
             stroke="currentColor"
             stroke-width="2"
             fill="none"
             stroke-linecap="round"
             stroke-linejoin="round">
          <line x1="12"
                y1="19"
                x2="12"
                y2="5"></line>
          <polyline points="5 12 12 5 19 12"></polyline>
        </svg>
      </button>
    </transition>

    <ChatService />
  </div>
</template>

<script>
import AppHeader from './components/AppHeader.vue'
import AppFooter from './components/AppFooter.vue'
import ChatService from './components/ChatService/ChatService.vue'
import { buildMetaInfo } from './seo/buildMetaInfo'

export default {
  name: 'App',
  metaInfo() {
    const path = this.$route && this.$route.path ? this.$route.path : '/'
    const locale = this.$i18n && this.$i18n.locale ? this.$i18n.locale : 'zh-CN'

    const getter =
      this.$store &&
      this.$store.getters &&
      this.$store.getters['seo/getSeoByPathAndLocale']

    const seoRecord = typeof getter === 'function' ? getter(path, locale) : {}
    const fallbackTitle = this.$t ? this.$t('common.logoAlt') : 'Zhongze'

    return buildMetaInfo({
      seoRecord,
      fallbackTitle,
    })
  },
  components: {
    AppHeader,
    AppFooter,
    ChatService,
  },
  data() {
    return {
      showBackToTop: false,
      wechatWorkLink: 'https://work.weixin.qq.com/ca/cawcded5290a632d92',
      wechatWorkIcon: require('@/assets/qiwei.png'),
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      this.showBackToTop = window.scrollY > 300;
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }
}
</script>

<style>
@font-face {
  font-family: "Space Grotesk";
  src: url("../fontstyle/SpaceGrotesk-Regular.otf") format("opentype");
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}

:root {
  --font-primary: "Space Grotesk", "Helvetica Neue", Helvetica, "PingFang SC",
    "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  --font-secondary: "Space Grotesk", "Helvetica Neue", Helvetica, "PingFang SC",
    "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}

body {
  margin: 0;
  padding: 0;
  font-family: var(--font-primary);
}

#app {
  font-family: var(--font-primary);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  min-height: 100vh;
  background-color: #fff;
}

.back-to-top {
  position: fixed;
  bottom: 40px;
  right: 40px;
  width: 50px;
  height: 50px;
  background-color: #2ea2fa;
  color: white;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 9999;
  transition: all 0.3s ease;
  outline: none;
}

.back-to-top:hover {
  background-color: #007acc;
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.wechat-work-container {
  position: fixed;
  right: -10px;
  top: 60%;
  transform: translate(-50%, -50%);
  z-index: 10000;
}

.wechat-work-icon {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  text-decoration: none;
  user-select: none;
}

.wechat-work-bg {
  width: 46px;
  height: 46px;
  border-radius: 50%;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  
  transition: transform 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease;
}

.wechat-work-icon:hover .wechat-work-bg {
  transform: scale(1.05);
  background: #007acc;
 
}

.wechat-work-text {
  font-size: 12px;
  line-height: 1;
  color: #2c3e50;
  padding: 6px 10px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.9);

}

@media (max-width: 768px) {
  .wechat-work-container {
    left: auto;
    right: 16px;
    top: 50%;
    transform: translateY(-50%);
  }
}
</style>
